<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>The Julius-Claudian House</h1>
</div>
</div>
<p class="first">
	Julius Caesar left no direct heir, since his only daughter, Julia, wife of Pompey, died childless. But his line continued through his niece, Atia, and his great-nephew and adopted son, who ruled the Roman Empire after Julius Caesar’s death and came to be called “the Divine Augustus.”</p>
<div class="figure">
<img alt="" src="images/img001.jpg" style="margin-top: 10px; margin-bottom: 10px;"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_xxxxxxxxxxxxx_Dedication.vue?6b8f4dd2